import $ from 'jquery'

const SHARED_CONFIG_YEAR_SELECT_IDENTIFIER =
  "[data-behaviour='shared-config-year-select']"
const SHARED_CONFIG_MAPPING_LIST_SELECT_IDENTIFIER =
  "[data-behaviour='shared-config-mapping-list-select']"

onDomLoad(function ($dom) {
  function withoutEmptyFields(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v))
  }

  function loadPageWithSelectedInputs({ mode = null }) {
    const year = $dom.find(SHARED_CONFIG_YEAR_SELECT_IDENTIFIER).val()
    const mappingListId = $dom
      .find(SHARED_CONFIG_MAPPING_LIST_SELECT_IDENTIFIER)
      .val()

    const queryStringParams = withoutEmptyFields({
      y: year,
      ml: mappingListId,
      m: mode,
    })
    window.location.href =
      window.location.pathname + '?' + $.param(queryStringParams)
  }

  $dom.on(
    'change',
    SHARED_CONFIG_YEAR_SELECT_IDENTIFIER,
    loadPageWithSelectedInputs
  )

  $dom.on(
    'change',
    SHARED_CONFIG_MAPPING_LIST_SELECT_IDENTIFIER,
    loadPageWithSelectedInputs
  )
})
